<div class="upload-frame mat-elevation-z8">
  <app-header [componentName]="compName"></app-header>
  <div class="spinner-Overlay" *ngIf="displaySpinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <div class="settingsdiv">
    <div class="header-container">
      <h6>{{ "SettingsData.Settings" | translate }}</h6>
    </div>
    <div class="sub-container">

      <div class="block-1">
        <div class="content-1">
          <p class="sub-heading font-SN-core">
            {{ "SettingsData.AuditLog" | translate }}
          </p>
          <p class="user-content font-SN-book">
            {{ "SettingsData.AuditlogDetails" | translate }}
          </p>
        </div>
        <div class="button">
          <button class="btn-SN-default btn-create-log" (click)="openDateRange()">
            {{ "SettingsData.Create" | translate }}
          </button>
        </div>
      </div>
      <hr class="ml-25" />

      <div class="block-2">
        <div class="content-1">
          <p class="sub-heading font-SN-core">
            {{ "SettingsData.Version" | translate }}
          </p>
          <p class="user-content font-SN-book">
            {{ "SettingsData.VersionHILDetails" | translate }} {{ hilVersion }}
          </p>
          <p class="user-content font-SN-book">
            {{ "SettingsData.VersionPRIMEDetails" | translate }} {{ primeSegVerion }}
          </p>
          <p class="user-content font-SN-book">
            {{ "SettingsData.VersionTIBIADetails" | translate }} {{ tibiaSegVersion }}
          </p>
        </div>
      </div>
      <hr class="ml-25" />
    </div>
  </div>
</div>
